import { FormArray, FormControl, FormGroup } from '@angular/forms';

import { ContractAnnexLineForm } from '@gi/forms/contract-annex-line-form';
import { ContractAnnex } from '@gi/models/contract-annex';
import { ContractAnnexLine } from '@gi/models/contract-annex-line';
import { ContractOffer } from '@gi/models/contract-offer';

export type ContractAnnexFormType = {
  id: FormControl<number | undefined>;
  label: FormControl<string | null>;
  lines: FormArray<ContractAnnexLineForm>;
  contractOffer: FormControl<ContractOffer | null>;
};

export class ContractAnnexForm extends FormGroup<ContractAnnexFormType> {
  get id(): FormControl<number | undefined> {
    return this.controls.id;
  }

  get label(): FormControl<string | null> {
    return this.controls.label;
  }

  get lines(): FormArray<ContractAnnexLineForm> {
    return this.controls.lines;
  }

  get contractOffer(): FormControl<ContractOffer | null> {
    return this.controls.contractOffer;
  }

  constructor() {
    super({
      id: new FormControl<number | undefined>(undefined),
      label: new FormControl<string | null>(null),
      lines: new FormArray<ContractAnnexLineForm>([]),
      contractOffer: new FormControl<ContractOffer | null>(null)
    });
  }

  fromContractAnnex(annex: ContractAnnex): void {
    this.patchValue({
      id: annex.id,
      label: annex.label,
      contractOffer: annex.offer
    });

    this.lines.clear();

    annex.lines.forEach((line: ContractAnnexLine) => this.addLine(line));
  }

  toContractAnnex(): ContractAnnex {
    return new ContractAnnex(
      this.id.value,
      this.label.value,
      this.lines.controls.map((lineForm: ContractAnnexLineForm) => lineForm.toContractAnnexLine()),
      this.contractOffer.value
    );
  }

  addLine(line: ContractAnnexLine): void {
    const lineForm = new ContractAnnexLineForm();
    lineForm.fromContractAnnexLine(line);
    this.lines.push(lineForm);
  }

  disableTypeAndLabelFromLines(): void {
    this.lines.controls.forEach((lineForm: ContractAnnexLineForm) => {
      lineForm.type.disable();
      lineForm.label.disable();
    });
  }
}
